import DragDropFileUploader from './drag-drop-uploader';

export default DragDropFileUploader;
